import { IRootState } from "../reducers/root";

export function selectIxsRef(state: IRootState): string {
    return (
        (state.session.user.token?.sidSubst !== ""
            ? state.session.user.token?.sidSubst
            : state.session.user.token?.sid) ?? ""
    );
}
